import { render, staticRenderFns } from "./MenuItemSheet.vue?vue&type=template&id=2cdacd04"
import script from "./MenuItemSheet.vue?vue&type=script&lang=js"
export * from "./MenuItemSheet.vue?vue&type=script&lang=js"
import style0 from "./MenuItemSheet.vue?vue&type=style&index=0&id=2cdacd04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports